import { Grade, MeInfoStore } from './auth';

interface TSignatureImageList {
  idx: number;
  storeId: string;
  type: string;
  image: string;
  displayOrder: number;
  createDate: Date;
  createdBy: string;
  lastModifiedDate?: Date;
  lastModifiedBy?: string;
}
interface TNoticeImageList {
  idx: number;
  storeId: string;
  type: string;
  image: string;
  displayOrder: number;
  createDate: Date;
  createdBy: string;
  lastModifiedDate?: Date;
  lastModifiedBy?: string;
}

interface TMenuImageList {
  idx: number;
  storeId: string;
  type: string;
  image: string;
  displayOrder: number;
  createDate: Date;
  createdBy: string;
  lastModifiedDate?: Date;
  lastModifiedBy?: string;
}

export interface StoreType {
  sid: string;
  id: string;
  name: string;
  intro: string;
  phone?: string;
  cellphone?: string;
  address?: string;
  addressType?: 'R' | 'J';
  zoneCode?: string;
  roadAddress?: string;
  jibunAddress?: string;
  addressDetail?: string;
  cancelfunc: boolean;
  cancelpwchange: boolean;
  cancelpw: string;
  pushcoupon: boolean;
  bizname?: string;
  bizserial?: string;
  bankCode?: string;
  bankAccount?: string;
  bankAccountHold?: string;
  supplyType: number;
  isBooking: boolean;
  isCafeteriaPw: boolean;
  isExposeDeliveryRequirement?: boolean;
  thumbnailImage?: string;
  signatureImageList?: Array<TSignatureImageList>;
  menuBoardImageList?: Array<TMenuImageList>;
  noticeImageList?: Array<TNoticeImageList>;
  noticePopupImageList?: Array<TNoticeImageList>;
  isTermsAgree: boolean;
  meInfoCurrent?: MeInfoStore;
  isManagementMenuStock: boolean;
}

export interface StoreImagesType {
  isRegisterThumbnailImage: boolean;
  canRegisterThumbnailImage: boolean;
  isRegisterSignatureImage: boolean;
  canRegisterSignatureImage: boolean;
  isRegisterMenuBoardImage: boolean;
  canRegisterMenuBoardImage: boolean;
  isRegisterNoticeImage: boolean;
  canRegisterNoticeImage: boolean;
  isRegisterNoticePopupImage: boolean;
  canRegisterNoticePopupImage: boolean;
}

export type TStoreImageType =
  | 'STORE_IMAGE_TYPE_SIGNATURE'
  | 'STORE_IMAGE_TYPE_MENU_BOARD'
  | 'STORE_IMAGE_TYPE_NOTICE'
  | 'STORE_IMAGE_TYPE_NOTICE_POPUP';

export interface IStoreImageOrderRequest {
  type: TStoreImageType;
  storeImages: { idx?: number; displayOrder: number; imageUrl: string }[];
}

export interface IStoreThumbnailRequest {
  imageUrl: string;
}

export interface DisplayData {
  storeName: string;
  storePhone: string;
  addressType: string;
  zoneCode: string;
  roadAddress: string;
  jibunAddress: string;
  addressDetail: string;
  mainCategoryIdx: number[];
}

export interface ISaveAppDisplayInfo {
  storeId: string;
  displayData: DisplayData;
}

export type EmployeeStatus = 'PREPARATION' | 'CANCEL' | 'REFUSE' | 'REST' | 'WORK' | 'DELETE';

export const employeeTypeMap = {
  PREPARATION: '대기중',
  CANCEL: '취소',
  REFUSE: '거절',
  REST: '휴직중',
  WORK: '근무중'
};

export interface Employee {
  employeeApplyIdx: 0;
  name: string;
  cellPhone: string;
  status: string | EmployeeStatus;
  inviteDate: 0;
  approveDate: 0;
}

export interface Worker {
  employeeApplyIdx: 0;
  storeId: string;
  storeName: string;
  storeAddress: string;
  grade: Grade;
  status: string | EmployeeStatus;
  inviteDate: 0;
  approveDate: 0;
}

export interface CouponParam {
  sid: string;
  date: string;
}

export type CouponParamPaging = CouponParam & { page: number; pageRow: number; payRoomIdx?: string };

export type TInfiniteReturn<T> = {
  data: T;
  nextId: number | null;
  previousId: number | null;
};

export interface CouponDetailResponse {
  isCancelable: boolean;
  hasNonRefundableReasons: boolean;
  nonRefundables: any[];
  coupon?: any;
  menus?: any[];
  shippingFeeInfo?: any;
}

// 엑셀파일 보관함
export interface ExcelStorageItem {
  fileId: string;
  said: string;
  storeAccountName: string; // 요청자 이름 (StoreAccount.name)
  sid: string;
  storeName: string; // 요청 제휴점명 (Store.name)
  requestDate: string; // 요청 일시 (ISO date-time)
  makeDate: string | null; // 생성 일시 (생성 전이면 null)
  expireDate: string; // 만료 일시 (요청일 + 90일)
  contentType: string;
  contentTypeName: string; // 엑셀 종류 명칭 (공통코드 STORE_EXCEL_LOG_CONTENT_TYPE)
  downCount: number;
  status: number; // 0 삭제됨 / 2 생성중 / 4 생성실패 / 5 다운로드 / 99 삭제
  statusName: string;
}

export interface ExcelStorageResponse {
  totalCount: number;
  content: ExcelStorageItem[];
}

export interface ExcelStorageParams {
  page: number; // 1부터
  year?: number;
  sid?: string;
  contentType?: string;
}
